import { ErrorReportingClient } from '../types/ErrorReportingClient';
import { ErrorReportingDevtools } from '../types/ErrorReportingDevtools';

/**
 * Returns a snapshot of the user/tags/extra/breadcrumb data that the
 * error-reporting client will attach to the next outgoing event. The
 * client adapter is responsible for merging vendor-specific scope
 * structures into the snapshot shape.
 */
export const createGetScopeDevtool = (
  client: ErrorReportingClient,
): ErrorReportingDevtools['getScope'] => {
  return () => client.getScopeSnapshot();
};
